import { render, staticRenderFns } from "./AppVideo1.vue?vue&type=template&id=1ed9be7c&scoped=true&"
import script from "./AppVideo1.vue?vue&type=script&lang=js&"
export * from "./AppVideo1.vue?vue&type=script&lang=js&"
import style0 from "./AppVideo1.vue?vue&type=style&index=0&id=1ed9be7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed9be7c",
  null
  
)

export default component.exports